import { authHeader } from '../../_helpers';
import axios from 'axios';

export const allotmentSummaryService = {
    getAllotmentSummaryHandler,
   
  
};
axios.defaults.headers.common = authHeader();

function getAllotmentSummaryHandler() {
    let token = localStorage.getItem('access_token')

    return axios.get(`/assessments/allotment/summary/?access_token=${token}`)
        .then(response => {
            return response;
        });
}



// WEBPACK FOOTER //
// ./src/_services/allotmentSummary/allotmentSummary.service.js